<template>
  <div style="background-color:#fff;min-height:500px" class="cont_inner">
    <div style="border:1px solid #cdcdcd">
      <div style="height:160px;background-color:#f9f9f9;border-bottom: 1px solid #cdcdcd ; display:flex; justify-content:center;align-items:center;padding:10px">
        <div style="width:200px;text-align:center;color:#f90000">
          <i class="el-icon-success" style="font-size:36px;"></i>
          <div style="margin-top:10px">交易成功</div>
        </div>
        <div style="display:flex;color:gray;text-align:center;flex:1">
          <div style="margin-left:67px">
            <div style="margin-bottom:7px;font-size: 16px;color: #999999 ">订单编号</div>
            <div style="font-size: 14px;color: #666666;">
              {{ orders.orderNo }}
            </div>
          </div>
          <div style="margin-left:48px">
            <div style="margin-bottom:7px;font-size: 16px;color: #999999 ">下单时间</div>
            <div style="font-size: 14px;color: #666666;">
              {{ orders.createTime }}
            </div>
          </div>
          <div style="margin-left:48px">
            <div style="margin-bottom:7px;font-size: 16px;color: #999999 ">完成时间</div>
            <div style="font-size: 14px;color: #666666;">
              {{ orders.receiptTime }}
            </div>
          </div>
        </div>
        <!-- <div>
          <el-button type="danger">立即付款</el-button>
          <el-button type="primary" plain>取消订单</el-button>
        </div> -->

      </div>
      <div style="padding:40px;color:gray">
        <div
          v-if='deliverData.length > 0'
          style="height: 48px;background-color: #F9F9F9;border: 1px solid rgb(228, 228, 228);height:48px;margin-bottom:48px;display:flex;align-items:center">
          <div style="flex:1;margin-left:20px;font-size: 12px;color: #999999 /">
            {{ deliverData[0].context }}
          </div>
          <el-button type="danger" style="margin-right:20px" size='mini' plain
          @click="deliverdialogVisible = true "
          >查看物流</el-button>

        </div>

        <div style="font-size: 16px;color: #999999 ; margin-bottom:14px">商品信息</div>
        <el-table
          ref="multipleTable"
          :data="orders.apiOrderGoods"
          tooltip-effect="dark"
          style="width: 100% ; margin-top:20px;border:1px solid #e4e4e4"
          :row-style="{height: '100px'}"
          :header-cell-style="{background:'#F9F9F9',color:'#999999'}"
          @row-click='gotoDetail'
        >
          <el-table-column label="商品信息"  >
            <template slot-scope="scope">
              <div style="display:flex;   	">
                <el-image style="width: 50px; height: 50px" :src="publicUrl  + scope.row.goodsPic" fit="contain"></el-image>
                <div
                  style="flex:1;margin-left:8px;display:flex;flex-direction:column;justify-content:center"
                >
                  <div style="font-size: 14px;color: #333333;">{{ scope.row.goodsName }}</div>
                  <div style="font-size: 14px;color: #333333;" v-if=' scope.row.searchValue '>{{ scope.row.searchValue }}</div>
                  <div style="font-size: 14px;color: #333333;" v-if=' scope.row.vin '>{{ scope.row.vin }}</div>

                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="price" label="单价" width="250" align="center">
            <template slot-scope="scope">
              <div style="display:flex;justify-content:center">
                <div style="color: #7F7F7F;margin-right:20px">
                  <div>零售价</div>
                  <div>{{ scope.row.goodsPrice  ? '¥' + scope.row.goodsPrice  : ''  }}</div>
                </div>
                <div style="color: #E60012;margin-right:20px">
                  <div>拿货价</div>
                  <div>{{ scope.row.goodsDiscountPrice  ? '¥' + scope.row.goodsDiscountPrice  : '已失效'  }}</div>
                </div>

                <div style="color: #E60012;"  >
                  <div>实付金额</div>
                  <div>{{ scope.row.realAmount  ? '¥' + scope.row.realAmount  : ''  }}</div>
                </div>
                <div>
                </div>
              </div>
            </template>

          </el-table-column>

          <el-table-column prop="num" label="数量"  width="80" align="center">
            <template slot-scope="scope">
              {{  scope.row.quantity  }}{{  scope.row.salesUnit  }}
            </template>
          </el-table-column>
          <el-table-column prop="price" label="小计" width="120" align="center">
            <template slot-scope="scope">
              <div style="color:red"> {{ '¥' + (scope.row.goodsDiscountPrice * scope.row.quantity).toFixed(2) }} </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="160" align="center">
            <template slot-scope="scope">
              <div style="display:flex;justify-content:center">
                <!-- <div
                  class="background_style btn"
                  :style="{backgroundImage: 'url(' + btn_black + ')' }"
                  v-if=" scope.row.afterSaleId &&  (scope.row.afterSaleStatus == 4 || scope.row.afterSaleStatus == 8 )"
                >
                  已关闭
                </div>
                <div
                  class="background_style btn"
                  :style="{backgroundImage: 'url(' + btn_red + ')' }"
                  v-else-if=" scope.row.afterSaleId "
                >
                  售后中
                </div> -->
                <div
                  class="background_style btn"
                  :style="{backgroundImage: 'url(' + btn_black + ')' }"
                  v-if='  scope.row.afterSaleQuantity < scope.row.quantity  '
                  @click.stop="afterSaleClick( scope.row )"
                  style="cursor : pointer"
                >
                  售后
                </div>
              </div>


            </template>
          </el-table-column>

        </el-table>

        <div style="margin:34px 0 14px;font-size: 16px;color: #999999">收货信息</div>
        <div style="border:1px solid #cdcdcd ;padding:20px;font-size:14px;margin-bottom:30px">
          <div style="margin-bottom:12px;font-size: 14px;color: #666666;">
            <span style="display:inline-block;width:100px;font-size: 14px;color: #999999 ">收货人:</span>
            {{ orders.receiverName }}
          </div>
          <div style="margin-bottom:12px;font-size: 14px;color: #666666;">
            <span style="display:inline-block;width:100px;font-size: 14px;color: #999999 ">联系方式 :</span>
            {{ orders.receiverPhone }}
          </div>
          <div style="font-size: 14px;color: #666666;">
            <span style="display:inline-block;width:100px;font-size: 14px;color: #999999">收货地址 :</span>
            {{ orders.receiverProvince + orders.receiverCity + orders.receiverRegion + orders.receiverDetailAddress }}
          </div>
        </div>

        <div style="margin:34px 0 14px;font-size: 16px;color: #999999">支付方式及物流方式</div>
        <div style="border:1px solid #cdcdcd ;padding:20px;font-size:14px;margin-bottom:30px">
          <div style="margin-bottom:12px;font-size: 14px;color: #666666;">
            <span style="display:inline-block;width:100px;font-size: 14px;color: #999999">支付方式：</span>
            {{ orders.payChannel == 4 ? '银行转账'  : ''}}
            {{ orders.payChannel == 1 ? '微信'  : ''}}
            {{ orders.payChannel == 2 ? '支付宝'  : ''}}
          </div>
          <div style="font-size: 14px;color: #666666;margin-bottom:12px;">
            <span style="display:inline-block;width:100px;font-size: 14px;color: #999999">发货仓库：</span>
            {{ subWarehouseName}}
          </div>
          <div style=";font-size: 14px;color: #666666;margin-bottom:12px;">
            <span style="display:inline-block;width:100px;font-size: 14px;color: #999999">物流方式：</span>
            {{ orders.expressCompany }}
          </div>
          <div style="font-size: 14px;color: #666666;">
            <span style="display:inline-block;width:100px;font-size: 14px;color: #999999">物流单号：</span>
            {{ orders.expressNo }}
          </div>
        </div>

        <div style="margin:34px 0 14px;font-size: 16px;color: #999999" v-if="orders.invoiceCity">发票信息</div>
        <div style="border:1px solid #cdcdcd ;padding:20px;font-size:14px;margin-bottom:30px" v-if="orders.invoiceCity">
          <div style="margin-bottom:12px;font-size: 14px;color: #666666;">
            <span style="display:inline-block;width:100px;font-size: 14px;color: #999999">发票类型：</span>
            {{ orders.invoiceProperty == 0 ? '普通发票' : '专用发票' }}
          </div>
          <div style="font-size: 14px;color: #666666;">
            <span style="display:inline-block;width:100px;font-size: 14px;color: #999999">发票抬头：</span>
            {{ companyName }}
          </div>
        </div>

        <div style="margin:34px 0 14px;font-size: 16px;color: #999999">订单信息</div>
        <div style="border:1px solid #cdcdcd ;padding:20px;font-size:14px;margin-bottom:30px">
          <div style="margin-bottom:12px;font-size: 14px;color: #666666;">
            <span style="display:inline-block;width:100px;font-size: 14px;color: #999999">订单编号：</span>
            {{ orders.orderNo }}
          </div>
          <div style="font-size: 14px;color: #666666;">
            <span style="display:inline-block;width:100px;font-size: 14px;color: #999999">下单时间：</span>
            {{ orders.createTime }}
          </div>
        </div>

        <div style="margin:34px 0 14px;font-size: 16px;color: #999999">订单备注</div>
        <div style="border:1px solid #cdcdcd ;padding:20px;font-size:14px;margin-bottom:30px">
          <div style="margin-bottom:12px;font-size: 14px;color: #666666;">
            {{ orders.remark }}
          </div>
        </div>

        <div style="display:flex;margin-bottom:10px">
          <div style="text-align:left;flex:1;font-size: 14px;color: #666666;">
            商品件数：
          </div>
          <div style="width:150px;font-size: 14px;color: #D10217;;text-align:right">
            {{ orders.totalNum }}件
          </div>
        </div>
        <div style="display:flex;margin-bottom:10px">
          <div style="text-align:left;flex:1;font-size: 14px;color: #666666;">
            商品总价：
          </div>
          <div style="width:150px;font-size: 14px;color: #D10217;;text-align:right">
            ¥{{ orders.goodsTotalPrice}}
          </div>
        </div>
        <div style="display:flex;margin-bottom:10px">
          <div style="text-align:left;flex:1;font-size: 14px;color: #666666;">
            活动优惠：
          </div>
          <div style="width:150px;font-size: 14px;color: #D10217;;text-align:right">
            -¥0
          </div>
        </div>
        <div style="display:flex;margin-bottom:10px">
          <div style="text-align:left;flex:1;font-size: 14px;color: #666666;">
            优惠券抵扣：
          </div>
          <div style="width:150px;font-size: 14px;color: #D10217;;text-align:right">
            -¥{{ orders.couponTotalPrice }}
          </div>
        </div>
        <div style="display:flex;margin-bottom:10px"  v-if="orders.orderType==1">
          <div style="text-align:left;flex:1;font-size: 14px;color: #666666;">
            预定优惠：
          </div>
          <div style="width:150px;font-size: 14px;color: #D10217;;text-align:right">
            -¥{{ orders.resvPrice }}
          </div>
        </div>
        <div style="display:flex;margin-bottom:10px">
          <div style="text-align:left;flex:1;font-size: 14px;color: #666666;">
            运费：
          </div>
          <div style="width:150px;font-size: 14px;color: #D10217;;text-align:right">
            ¥{{ orders.postage }}
          </div>
        </div>
        <div style="display:flex;margin-bottom:10px;margin-top:25px;line-height:22px;">
          <div style="text-align:left;flex:1;font-size: 14px;color: #666666;">
            应付总额：
          </div>
          <div style="width:150px;font-size: 20px;font-weight: 700;color: #D10217;;text-align:right">
            ¥{{ orders.payPrice}}
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title="查看物流"
      :visible.sync="deliverdialogVisible"
      width="600"
      center
    >
      <div style="width: 100%;border: 1px solid rgb(237, 237, 237);">
        <div style="padding:20px;background-color: #F9F9F9;border-bottom: 1px solid rgb(237, 237, 237);">
          <div style="margin-bottom:8px;font-size: 14px;color: #999999">
            <span style="font-size: 14px;font-weight: 700;color: #999999;width:70px">配送企业:</span>
            {{ orders.expressCompany }}
          </div>
          <div style="margin-bottom:8px;font-size: 14px;color: #999999 ">
            <span style="font-size: 14px;font-weight: 700;color: #999999;width:70px">快递单号:</span>
            {{ orders.expressNo }}
          </div>
          <div style=";font-size: 14px;color: #999999">
            <span style="font-size: 14px;font-weight: 700;color: #999999;width:70px">联系电话:</span>
            {{ orders.receiverPhone }}
          </div>
        </div>
        <div style="height:395px;border-bottom: 1px solid rgb(237, 237, 237);overflow-y:auto;padding:20px 0 ">
          <el-timeline>
            <el-timeline-item
              v-for="(activity, index) in deliverData"
              :key="index"
              :timestamp="activity.ftime"
              :color="activity.color"
            >
              {{activity.context}}
            </el-timeline-item>
          </el-timeline>
        </div>
      </div>
      <span slot="footer" class="dialog-footer" style="display:flex;justify-content:center">
        <div
          class="background_style btn"
          :style="{backgroundImage: 'url(' + btn_red + ')' }"
          @click="deliverdialogVisible = false"
          style="cursor : pointer"
        >
          确定
        </div>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import {  getOrderDetailReq , queryTrackReq } from '@/api/Order/index'

export default {
  data() {
    return {
      publicUrl : this.common.publicUrl ,
      btn_red : this.common.publicUrl + '/profile/avatar/u146.png' ,
      btn_black : this.common.publicUrl + '/profile/avatar/u147.png' ,
      orders: {

      } ,
      deliverData : [] , //物流数据
      deliverdialogVisible : false ,
      companyName:'',
      subWarehouseName:''
    };
  },

  methods: {
    getOrderDetail(){
      return new Promise( (resolve, reject) => {
        getOrderDetailReq({
          orderNo : this.obj.orderNo ,
        }).then( res => {

          if (res.data.status == 0) {
            this.companyName =res.data.companyName;
            this.subWarehouseName =res.data.subWarehouseName;
            res.data.orders.receiptTime_ = res.data.orders.receiptTime.substring(0,10)
            res.data.orders.createTime_ = res.data.orders.createTime.substring(0,10)
            res.data.orders.receiverPhone_ = res.data.orders.receiverPhone.substring( 0 , 3 ) + '****' + res.data.orders.receiverPhone.substring( res.data.orders.receiverPhone.length -4  )

            let receiptTime = res.data.orders.receiptTime.replace(/-/g, '/') //售后时间
            let receiptTimeDate = new Date(receiptTime).getTime()
            let today = new Date().getTime()
            if( ( ( today - receiptTimeDate ) / 86400000 ) < 365  ){
              res.data.orders.canAfterSale = true
            }else {
              res.data.orders.canAfterSale = false
            }

            this.orders = res.data.orders
            resolve()
          }else{
            this.$message({
              message: res.data.statusDesc ,
              type: 'warning'
            });
          }


        })
      })

    },
    queryTrack(){
      if( !this.orders.expressCode || !this.orders.expressNo  ){
        return false
      }
      queryTrackReq({
        com : this.orders.expressCode ,
        num : this.orders.expressNo,
        receiverPhone:this.orders.receiverPhone,
        receiverName:this.orders.receiverName,
        orderNo:this.orders.orderNo,
      }).then( res => {
        if (res.data.status == 0) {
          res.data.queryTrack.data[0].color = '#f90000'
          this.deliverData =  res.data.queryTrack.data
        }else{
          this.$message({
            message: res.data.statusDesc ,
            type: 'warning'
          });
        }

      } )
    },
    afterSaleClick( row ){
      // console.log( row )
      let obj = {}
      obj.orderNo = this.orders.orderNo
      obj.orderGoodsId = row.orderGoodsId
      obj.quantity = row.quantity

      this.$router.push({
        name: 'ApplyAftersale' ,
        query: {
          params: JSON.stringify( obj )
        }
      })
    },
    //去商品详情
    gotoDetail(item){
      let goodsId = item.goodsId
      let jancode = item.jancode
      this.$router.push({
        path: '/goodDetail',
        query: {
          goodsId: goodsId ,
          jancode : jancode
        }
      })
    }
  },
  created(){
    let obj =  JSON.parse( this.$route.query.params )
    this.obj = obj
    this.getOrderDetail().then( () => {
      this.queryTrack()
    } )
  },
  computed : {
    moduleUser() {
      return this.$store.state.moduleUser; // 这里返回的是：{name: 'wang', age: 22}
    }
  },
};
</script>

<style scoped lang="stylus">
.cont_inner >>> .el-table--enable-row-hover .el-table__row:hover{
  cursor : pointer
}
</style>
